import React from 'react'
import { Link } from 'react-router-dom';

import '../css/tabresponsive.css';


import HorizontalTabs from '../components/HorizontalTabs';

function parentorientationibdp() {

  const tabs = [
    { title: 'IBDP Orientation', content: () => <div>
    
    <div className='cam-lower-sec'>
   <h1 className='title'>Orientation for Parents and Students - IBDP</h1>
   </div>
   <div className='ibdp-parent-orientation'>
    <p>The Orientation session for parents and students of class X interested in the International Baccalaureate Diploma Programme (IBDP) at Sanskar School is designed to provide an overview of the programme and its requirements. The session aims to:</p>
    <p>Objectives:</p>
    <ol class="admission-class" type="1">
      <li>Introduce the IBDP framework, philosophy, and subject selection process.</li>
      <li>Explain the programme’s academic rigor and holistic learning approaches.</li>
      <li>Highlight the importance of time management, meeting deadlines, and balancing academics with personal growth.</li>
      <li>Provide clarity on key components like the Extended Essay (EE), Creativity, Activity, Service (CAS), and Theory of Knowledge (TOK).</li>
      <li>Emphasize the role of parents in supporting students’ academic and emotional well-being.</li>
      <li>Address questions regarding assessments, examinations, and pathways to university placements.</li>
    </ol>
    <br />
    <p>This orientation is essential for both parents and students to understand the expectations of the IBDP and the support needed to ensure success in the programme.</p>
    <p>By attending this session, students will gain clarity on the academic demands and opportunities for personal growth, while parents will understand how to actively support their child throughout the IBDP journey. Together, this shared understanding will foster a collaborative environment for achieving success.</p>
   </div>

   <div className="video-sec">
        <div className='video-box ibdp'>
          
<video controls width="100%" height="360px">
            <source src="/video/ibdp2.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        </div>
   {/* <div className='idbp-handbook-list'>
    <div className='handbook-box'>
    <Link  to="../pdf/ibdp-orientation/IBDP STUDENT PARENT ORIENTATION SESSION 2021-23.pdf"
        target="_blank"
        rel="noopener noreferrer"
    >
      <div className='handbook-img'>
      <img src='../img/ibdp-handbook/handbook-2022-24.webp'/>
      </div>
      IBDP Orientation
      
      </Link>


    </div>
    
   

 


   </div> */}



      
    </div> },
 
   
   
  
  ];
  return (
    <div>

    
    
<div className='ibdp-hero-sec'>
        <img src='img/Screenshot_29.webp'/>

      </div>
    <div className='igcse-data'>
        <HorizontalTabs tabs={tabs} />
    </div>

</div>
    
  )
}

export default parentorientationibdp
